import * as React from "react";
import { ODataParams, Query } from "../../Components/Query";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { DevicesTable } from "./DevicesTable";

export const DevicesList = () => {
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams) => {
        const filter = params.filter ? `(${params.filter})` : undefined;

        return await client.client.getDevices(undefined, filter, params.orderby, undefined, params.top, params.skip, undefined, true);
    }

    return (
        <DocumentTitle title="Device Administration | Vitalograph Web Portal">
            <div className="row">
                <div className="col-md-12">
                    <Query onRefresh={handleRefresh} initialOrdering={[{ field: "deviceType", condition: "asc" }, { field: "serialNumber", condition: "asc" }]}>
                        <DevicesTable />
                    </Query>
                </div>
            </div>
        </DocumentTitle>
    );
}
